import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import {
  CLEAR_JE_TYPE,
  FETCH_JE_TYPE_FAILURE,
  FETCH_JE_TYPE_LIST_FAILURE,
  FETCH_JE_TYPE_LIST_PROGRESS,
  FETCH_JE_TYPE_LIST_SUCCESS,
  FETCH_JE_TYPE_PROGRESS,
  FETCH_JE_TYPE_SUCCESS,
  FETCH_JE_ENTRY_FAILURE,
  FETCH_JE_ENTRY_LIST_FAILURE,
  FETCH_JE_ENTRY_LIST_PROGRESS,
  FETCH_JE_ENTRY_LIST_SUCCESS,
  FETCH_JE_ENTRY_PROGRESS,
  FETCH_JE_ENTRY_SUCCESS,
  CLEAR_JE_ENTRY,
  UPSERT_JE_ENTRY_SUCCESS,
  UPDATE_JE_ENTRY_RECONCILIATION_STATUS,
} from "./JeTypeAndEntryActions";
import { initialJeTypeAndEntryState } from "./JeTypeAndEntry.types";
import { AccountingJeTypeAndEntryActions } from ".";


export const AccountingJeTypeAndEntryReducer = (
  state: IStoreState["accounting"]["jeTypeAndEntry"] = initialJeTypeAndEntryState,
  action: AccountingJeTypeAndEntryActions
) => {
  switch (action.type) {
    case FETCH_JE_TYPE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.jeType.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_JE_TYPE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeType.loading = LoadState.Loaded;
        draftState.jeType.data = data;
      });
      return newState;
    }
    case FETCH_JE_TYPE_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeType.loading = LoadState.Failed;
        draftState.jeType.error = errorMessage;
      });
      return newState;
    }

    case FETCH_JE_TYPE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.jeType.listLoading = LoadState.InProgress;
        draftState.jeType.list = [];
      });
      return newState;
    }

    case FETCH_JE_TYPE_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeType.listLoading = LoadState.Loaded;
        draftState.jeType.list = data;
      });
      return newState;
    }

    case FETCH_JE_TYPE_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.jeType.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_JE_TYPE: {
      const newState = produce(state, (draftState) => {
        draftState.jeType.loading = LoadState.NotLoaded;
        draftState.jeType.data = initialJeTypeAndEntryState.jeType.data;
        draftState.jeType.error = null;
      });
      return newState;
    }

    case FETCH_JE_ENTRY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_JE_ENTRY_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.loading = LoadState.Loaded;
        draftState.jeEntry.data = Array.isArray(data) ? data : [];
      });
      return newState;
    }

    case FETCH_JE_ENTRY_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.loading = LoadState.Failed;
        draftState.jeEntry.error = errorMessage;
      });
      return newState;
    }

    case FETCH_JE_ENTRY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.listLoading = LoadState.InProgress;
        draftState.jeEntry.list = [];
      });
      return newState;
    }

    case FETCH_JE_ENTRY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.listLoading = LoadState.Loaded;
        draftState.jeEntry.list = data;
      });
      return newState;
    }

    case FETCH_JE_ENTRY_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case UPSERT_JE_ENTRY_SUCCESS: { 
      const data = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.loading = LoadState.Loaded;
        draftState.jeEntry.data = [...state.jeEntry.data, data];
      });
      return newState;
    }

    case CLEAR_JE_ENTRY: {
      const newState = produce(state, (draftState) => {
        draftState.jeEntry.loading = LoadState.NotLoaded;
        draftState.jeEntry.data = initialJeTypeAndEntryState.jeEntry.data;
        draftState.jeEntry.error = null;
      });
      return newState;
    }

    case UPDATE_JE_ENTRY_RECONCILIATION_STATUS: {
      const { uniqueJeCodes, reconciled, reconciledDate } = action.payload;
      return produce(state, (draftState) => {
        uniqueJeCodes.forEach((code: string) => {
          const index = draftState.jeEntry.list.findIndex(
            (x) => x.unique_je_code === code
          );
          if (index > -1) {
            draftState.jeEntry.list[index].reconciled = reconciled;
            draftState.jeEntry.list[index].reconciled_date = reconciledDate;
          }
        });
      });
    }

    default:
      return state;
  }
};
